import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.scss';
import aside from '../../assets/img/register1.jpg';
import InputText from 'components/InputText/InputText';
import { Button } from 'components/Button/Button';
import { AnchorText } from 'components/AnchorText/AnchorText';
import { HorizontalDivider } from 'components/HorizontalDivider/HorizontalDivider';
import axios from 'axios';
import { useUser } from '../../hooks/useUser';
import { safeLocalRedirect } from '../../utils/url';
import { useMutation } from 'react-query';
import Spinner from '../Spinner';
import { urlParameter } from '../../utils/url';
import { routes } from '../../routing/routes';

type LoginMutation = {
  username: string;
  password: string;
};

export const LOGIN_REDIRECT_PARAMETER = 'to';

const DusktechLogin = () => {
  const navigate = useNavigate();
  const { playfab, ethereum } = useUser();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const redirectTo = urlParameter(LOGIN_REDIRECT_PARAMETER);

  const { mutate: login, isLoading } = useMutation(
    async ({ username, password }: LoginMutation) => playfab.login(username, password),
    {
      async onSuccess() {
        if (redirectTo) {
          const toPage = safeLocalRedirect(redirectTo);
          // The functions undefined when the url isn't safe to navigate
          // we ignore it in that case and just continue to the base account
          if (toPage) {
            return navigate(toPage);
          }
        }

        navigate(routes.play());
      },
      onError(err) {
        if (axios.isAxiosError(err)) {
          setErrorMessage(err.response?.data.error.message)
        } else {
          setErrorMessage("Bad Username / Password Combination");
        }
      },
      retry: false,
    },
  );
  const holder = {
    background: 'url(' + aside + ') no-repeat center center',
    backgroundSize: 'cover',
  };

  useEffect(() => {
    if (!ethereum.isConnected) {
      navigate(routes.login());
    }
  }, [ethereum.isConnected, navigate]);

  const onSubmit: React.FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();
    login({ username, password });
  };

  return (
    <div className="row g-0 p-0">
      <div className="col has-bg">
        <div className="is-bg no-overlay" style={holder}></div>
      </div>

      <div className="col-12 col-sm-7 p-4 background-400">
        <h2 className="text-center mb-2 mt-2">Breaker ID Login</h2>
        <p className="text-center">
          Welcome back! Logging in with your Breaker ID will provide an enhanced gaming experience.
        </p>

        <HorizontalDivider className="my-4" />
        {errorMessage !== '' && 
          <div className="alert alert-danger">
            {errorMessage}
          </div>       
        }


        <form onSubmit={onSubmit}>
          <div className="form-elements m-0">
            <div>
              <InputText
                id="email-input"
                label="Email"
                value={username}
                onChange={(event) => {
                  setUsername(event.target.value);
                }}
                type="email"
                placeholder="you@domain.com"
              />
            </div>

            <div>
              <InputText
                className="mb-3"
                id="password-input"
                label="Password"
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
                type="password"
                placeholder="********"
              />

              <AnchorText href={routes.forgotPassword()}>Forgot password?</AnchorText>
            </div>

            <div className="mt-3 mb-3">
              <Button primary fullWidth disabled={isLoading || !username || !password}>
                {isLoading ? <Spinner color="white" width={12} height={12} /> : 'Login'}
              </Button>
            </div>
            <p className="form-footer">
              Don’t have an account? <AnchorText href={routes.register()}>Register Here</AnchorText>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DusktechLogin;
